// extracted by mini-css-extract-plugin
export default {"root":"FixedBackground_root__6o4mH","blend":"FixedBackground_blend__63ZsM"};